import Alt from "alt"
import ReactDOM from "react-dom"
import { Dispatcher } from "flux"
import { actionListener } from "./actionListener"

class DeliveryDispatcher extends Dispatcher {
  dispatch(payload) {
    super.dispatch(payload)
    actionListener.dispatch(payload)
  }
}

let instance = new Alt({
  dispatcher: new DeliveryDispatcher(),
  batchingFunction: ReactDOM.unstable_batchedUpdates,
})

if (process.env.NODE_ENV === "development") {
  window.deliveryAlt = instance
}

Alt.debug("delivery", instance)

export const alt = instance
